import { DataSource } from '@angular/cdk/collections';
import { AdminGuardService } from './../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, DoCheck } from '@angular/core';
import {MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { AuthService } from '../../servicios/auth.service';
import { UserGuardService } from '../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../servicios/guards/multi-user.service';
import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { read } from 'cfb/types';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';

//ngx-webcam 1
import {Subject} from 'rxjs';
import {Observable} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { environment } from "environments/environment";

//servicio global
import { GLOBALService } from "../../servicios/functions/GLOBAL.service";
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';

export interface PeriodicElement {
  i:string;
  cod_gasto: string;
  // fecha_carga: string;
  fecha_ticket: string;
  detalle: string;
  importe: string;
  categoria: string;
  imagen: string;
  //autorizante: string;
}
//tabla del jumbotron
var ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-nuevogasto',
  templateUrl: './nuevogasto.component.html',
  styleUrls: ['./nuevogasto.component.css']
})

export class NuevogastoComponent implements OnInit, DoCheck {
  //ngx-webcam 2
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
     //width: {ideal: 576},
     //height: {ideal: 1024}
  };
  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();

  //forma
  detallito:FormGroup;
  papito:FormGroup;
  //fin forma

  displayedColumns: string[] = ['i','cod_gasto', 'fecha_ticket', 'detalle', 'importe', 'categoria', 'imagen','x'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort) sort: MatSort;
  name: string;
  position: number;
  weight: number;
  symbol: string;

  viaje = true;
  secc = false;
  showFiller = false;
  profile: any;
  selectedDate;
  dateValue: any;
  proximo: string;

  userlog: string;
  detallePadre: string;
  motivoPadre: string;
  haydetalle;
  fecha_hoy;
  obsPadre: string;
  estPadre: string;
  gastoDePadre: string;
  tipo_gasto; //sistema o externo
  role;
  foto;
  fotodetalle;
  loading: boolean;
  i;
  hora;
  sumi;

  dataSourceCategorias;

  public uploader: FileUploader = new FileUploader({
    url: `${environment.backendUrl}/api/importador/importar`,
    itemAlias: 'foto',
    headers: [{ name: 'Access-Control-Allow-Origin', value: '*'}]
  });
  
  constructor(
    private http: HttpClient, // falta el private auth:AuthService
    public dialog: MatDialog,
    private datePipe: DatePipe, //para fecha_hoy
    //snackbar 2
    public snackBar: MatSnackBar,
    private global: GLOBALService
    ){
        //forma
        this.papito = new FormGroup({
          'motivo': new FormControl('', [Validators.required, Validators.pattern("^[0-9]{1,5}?$")]),
          'descripcion': new FormControl('', [Validators.required, Validators.pattern("^[0-9]{1,5}?$")]),
        });

        this.detallito = new FormGroup({
          'fecha_ticket': new FormControl('', [Validators.required]),
          //'importe': new FormControl('', [Validators.required, Validators.pattern("^[0-9]{1,5}([.][0-9]{2})?$")]),
          'importe': new FormControl('', [Validators.required, Validators.pattern("[1-9]{1}[0-9]{0,4}([.][0-9]{1,2})?$")]),
          'detalle': new FormControl(''),
          'categoria': new FormControl('', [Validators.required]),
          'autorizante': new FormControl(''),
          'imagen': new FormControl(null)
     })
      
       this.i=0;
       console.log(navigator.userAgent);
     }

  ngDoCheck(){
    console.log(this.estPadre);  
    this.suma();
    console.log("STRSUMI: " + this.strsumi);
    console.log("SUMI: " + this.sumi);
    console.log("detallito.importe=" + this.detallito.value.importe);
  }

  strsumi: string="";
  imim;
  add(){
    var detimp = Number(this.detallito.value.importe);
    this.sumi = this.sumi + detimp;
    if (this.strsumi==""){
      this.strsumi = this.detallito.value.importe;
    }else{
      this.strsumi =  (this.strsumi) +"-"+ (this.detallito.value.importe) ;
    }
    this.imim = 0;
    document.getElementById("mat-input-2").focus();
    //document.getElementById("mat-input-2").click();
  }

  refresh(){
    this.sumi=0;
    this.strsumi="";
    this.imim = 0;
    this.detallito.value.importe.reset;
    document.getElementById("mat-input-2").focus();
  }

  done(){
    this.detallito.value.importe = parseFloat(this.sumi).toFixed(2);
    this.imim = this.detallito.value.importe;
  }


  onActivate(event) {
    window.scroll(0,0);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
  }
     

  openDialog() {
    const dialogRef = this.dialog.open(NuevogastoComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
     
  fotos(){
    if (this.foto=='si'){
      this.foto='no';
    }else{
      this.foto='si';
    }
  }

  idsec;
  llenarCategorias(){
    //http://localhost:1337/api/llenarcategorias/ver?rol=PAGADOR
    this.http.get(`${environment.backendUrl}/api/llenarcategorias/ver?rol=${this.role}`)
    .subscribe((data: any[]) => {
      this.dataSourceCategorias=data;
      console.log(this.dataSourceCategorias); 
    });

  }

  deshabilitaRetroceso(){
    window.location.hash="no-back-button";
    window.location.hash="Again-No-back-button" //chrome
    window.onhashchange=function(){window.location.hash="no-back-button";}
  }

  ngOnInit() {
    this.sumi=0;
    this.getProximo();
    this.estPadre = 'PENDIENTE';
    console.log(this.i);
    this.deshabilitaRetroceso();
    this.role=localStorage.getItem('role');

    //lleno categorias
    this.llenarCategorias();

    ////ngx-webcam 2
    WebcamUtil.getAvailableVideoInputs()
    .then((mediaDevices: MediaDeviceInfo[]) => {
      this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
    });
  
    window.scroll(0,0);
    this.idsec=this.idsec=localStorage.getItem('seccional');
    this.blanquearTodo();
    this.limpiacam();
    
    this.foto='si';
    
    this.fecha_hoy= new Date;
    this.fecha_hoy = this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");    
    this.hora = this.global.horario();
    console.log("fecha: " + this.fecha_hoy);
    console.warn("hora: " + this.hora);

    this.dataSource.sort = this.sort;
    this.userlog=localStorage.getItem('userId');
  }


  //ngx-webcam 3
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean|string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    //console.log(this.webcamImage.imageAsDataUrl);
    //hago el resize de la fotodetalle antes de guardarlo
    console.log("resize imagen desde webcam..");
    this.fotodetalle=this.webcamImage.imageAsDataUrl;
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  limpiacam(){
    this.showWebcam = false;
    this.fotodetalle=[];
    this.fotodetalle=null;
    this.webcamImage=null;
  }

  // fin ngx-webcam 

  ngAfterViewInit() {
    
    //console.log("uploader ready");
    
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });

    //this.getProximo();
    //this.userlog=localStorage.getItem('userId');
  }

  prendeCamara(){
    //prende ngx-webcam 4
    this.showWebcam = true;  
  }

  scrollTop(){
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
          window.scrollTo(0, pos - 10); // how far to scroll on each step
      }else {
        window.clearInterval(scrollToTop);
      }
    },5);
  }

  apagaCamara(){
  
  }

  snackCamara(){
    // snackbar si encuentra al usuario
    this.snackBar.open('IMAGEN LISTA!!!', 'Cerrar', {duration: 3000});
  }

  addEvent( input: string, $event ) {
    this.selectedDate = moment($event.value).format('YYYY-MM-DD');
  }

  getProximo(){
    //llamo en el afterviewinitss
    this.http.get(`${environment.backendUrl}/api/importetotal/total`).subscribe((data: any[]) => {
      this.proximo = data["PROXIMO"];
      //console.log(this.proximo);
    });
    
  }
  
  sumita=0;
  guardarDetallito(){
    this.i=this.i+1;
    console.log(this.detallito.value);
    let data = { i: this.i, cod_gasto: this.proximo, fecha_ticket: moment(this.detallito.value.fecha_ticket).format('YYYY-MM-DD'),  detalle: this.detallito.value.detalle, 
                  importe: this.detallito.value.importe, categoria: this.detallito.value.categoria, imagen: this.fotodetalle };
    this.sumita = this.sumita + this.detallito.value.importe;
    ELEMENT_DATA.push(data);
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    this.haydetalle=ELEMENT_DATA
    this.fotodetalle=null;
    this.fotob64=null;
    this.detallito.reset();
    this.scrollTop();
    this.contarArray();
    this.refresh();
    
  }

  resizeImage(base64, maxWidth, maxHeight){

    // Max size for thumbnail
    if(typeof(maxWidth) === 'undefined')  maxWidth = 500;
    if(typeof(maxHeight) === 'undefined')  maxHeight = 500;

    // Create and initialize two canvas
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    var canvasCopy = document.createElement("canvas");
    var copyContext = canvasCopy.getContext("2d");

    // Create original image
    var img = new Image();
    img.src = base64;

    // Determine new ratio based on max size
    var ratio = 1;
    if(img.width > maxWidth)
      ratio = maxWidth / img.width;
    else if(img.height > maxHeight)
      ratio = maxHeight / img.height;

    // Draw original image in second canvas
    canvasCopy.width = img.width;
    canvasCopy.height = img.height;
    copyContext.drawImage(img, 0, 0);

    // Copy and resize second canvas to first canvas
    canvas.width = img.width * ratio;
    canvas.height = img.height * ratio;
    ctx.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL();
  }

  llenarEjemplo(){
    this.motivoPadre = 'VIAJE';
    this.detallePadre = 'GASTOS FONDO FIJO';
    this.obsPadre = 'ALGUNA OBSERVACION';
    this.detallito["fecha_ticket"]

    this.detallito = new FormGroup({
      'fecha_ticket': new FormControl('2019-01-01', [Validators.required]),
      'importe': new FormControl('777', [Validators.required, Validators.pattern("^[0-9]{1,5}([.][0-9]{2})?$")]),
      'detalle': new FormControl('GASTO DE INTERNET'),
      'categoria': new FormControl(''),
      'autorizante': new FormControl(''),
      'imagen': new FormControl(null)
 })

  }

  guardarDetallitoPrueba(){
    this.i=this.i+1;
    let data = { i: this.i, cod_gasto: this.proximo, fecha_ticket: '2018-12-14',  detalle: 'ALGUN GASTO MAX 30c', 
                  importe: '1233', categoria: '500000-0', imagen: this.fotodetalle };
    ELEMENT_DATA.push(data);
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    this.haydetalle=ELEMENT_DATA
    this.fotodetalle=null;
    this.fotob64=null;
    this.detallito.reset();
    this.scrollTop();
    this.contarArray();
    this.suma();
    
  }

  //GENERA NUEVO CODGASTO EN LA BASE Y SUS DETALLES
  enviarFormulario(){
    this.scrollTop();
    this.loading=true;
    //console.log(this.fotodetalle); base64 link de la foto capturada
    
    if (this.role=='USER'){
      this.estPadre = 'PENDIENTE';
      this.gastoDePadre = 'PROPIO';
    }
    console.log("*ESTADO: " + this.estPadre);
      
    console.log(this.detallePadre);
    this.tipo_gasto = 'SISTEMA';
    this.http.post(`${environment.backendUrl}/api/nuevodetalle/enviarform`, 
    {
      'detallePadre': this.detallePadre,
      'motivoPadre': this.motivoPadre,
      'usuario': this.userlog,
      'fechaPadre': this.fecha_hoy,
      'obsPadre': this.obsPadre,
      'estPadre': this.estPadre,
      'gastoDePadre': this.gastoDePadre,
      'tipo_gasto': this.tipo_gasto,
      'detalles': ELEMENT_DATA
    }
    ).subscribe(() => {
      console.log("NUEVO GASTO GENERADO!");     
      this.global.historicalTo("+NUEVO GASTO [" + this.proximo + "] - motivo: "+ this.motivoPadre+", detalle: "+ this.detallePadre + ", total: $" + this.parcial + ", a las: " + this.global.horario() + ", est: " + this.estPadre,'NUEVO-GASTO');
      this.haydetalle=null;
      this.blanquearTodo();
      this.loading=false;
      //this.llenarNoti();
      this.snackBar.open('GASTO ENVIADO CORRECTAMENTE!', 'Cerrar', {duration: 3000});
      
    });
  }

  noti;  
  llenarNoti(){
    if (this.role=='PAGADOR'){
      //http://localhost:1337/api/jorgenotifi/noti?est=AUTORIZADO
      this.http.get(`${environment.backendUrl}/api/jorgenotifi/noti?est=AUTORIZADO`)
        .subscribe((data: any[]) => {
        this.noti = data[0]["TOT"]; 
        localStorage.setItem('notipend',this.noti);
        console.log(`noti= ${localStorage.getItem('notipend')}`);   
      });
    }else{
    //http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
    this.http.get(`${environment.backendUrl}/api/notifi/noti?idse=${this.idsec}&est=PENDIENTE`)
      .subscribe((data: any[]) => {
      this.noti = data[0]["TOT"]; 
      localStorage.setItem('notipend',this.noti);
      console.log(`noti= ${localStorage.getItem('notipend')}`); 
    });
    }


  }

  quitarImagen(){
    this.fotodetalle=null;
    this.limpiacam();
    this.sumi = 0;
  }

  blanquearTodo(){
    //padre
    this.detallePadre = null;
    this.motivoPadre = null;
    this.obsPadre = null;
    //detalles
    this.haydetalle=null;
    this.dataSource.data = [];
    this.dataSource.data = null;
    this.foto=null;
    this.fotodetalle=null;
    ELEMENT_DATA = [];
    this.detallito.reset();
    //fotos
    this.fotob64 = null;
    //blanquea fotos
    this.limpiacam();
  }

  //para subir foto
  files;
  fotob64;

  getFiles(event) {
    this.files = event.target.files;
    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(this.files[0]); 
  }

  //obtengo base64 de imagen subida
  _handleReaderLoaded(readerEvt) {
    var b64String = readerEvt.target.result;
    this.fotob64=b64String
    //console.log(this.fotob64);
  }

  subirImagenDesdePc(){
    this.fotodetalle=this.fotob64;
    console.log("resize imagen subida deshabilitado");
    this.fotodetalle=this.fotodetalle;
  }
  
  parcial;
  items;
  suma(){
    var impbo = 0;
    var cont= 0;
    if (this.dataSource.data){
      for (var _j = 0; _j < (this.dataSource.data.length); _j++) {
        cont=cont+1;
        impbo=impbo+ Number(this.dataSource.data[_j]["importe"]);
      }
      console.log("parcial: "+ impbo);
      console.log("items: " + cont);
    }else{
      console.log("TODAVIA NO CARGO NINGUNO");
    }
    this.parcial = impbo;
    this.items = cont;
  }
  
  removeAt(x){
    var impbo = 0;
    console.log(`borrando fila nro: ${x}`);
    //recorre el array y obtiene la posicion donde encuentre el dato a buscar (x)
    var index:number = this.dataSource.data.indexOf(this.dataSource.data.find(h => h.i == x));
    console.log(`posicion del elemento: ${index}`);
    //borra desde la posicion que le mandas, y la cantidad que desees borrar contando esa posicion
    this.dataSource.data.splice(index, 1);
    this.dataSource.data.push();
    ELEMENT_DATA.push();
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    this.contarArray();
 
  }
  registros;
  contarArray(){
    //console.log(this.dataSource.data.length);
    this.registros=this.dataSource.data.length;
  }

  temporal;
  enviaItem(temp){
    localStorage.setItem('itemTempo',temp);
    this.temporal=localStorage.getItem("itemTempo");
    console.log(temp);
  }


}//fin clase nuevogasto


